export let STROKE_STYLE = /*#__PURE__*/function (STROKE_STYLE) {
  STROKE_STYLE["SOLID"] = "solid";
  STROKE_STYLE["DASHED"] = "dashed";
  STROKE_STYLE["DOTTED"] = "dotted";
  return STROKE_STYLE;
}({});
export let DOT_STYLE = /*#__PURE__*/function (DOT_STYLE) {
  DOT_STYLE["SQUARE"] = "square";
  DOT_STYLE["TRIANGULAR"] = "triangular";
  DOT_STYLE["CIRCULAR"] = "circular";
  DOT_STYLE["SHURIKEN"] = "shuriken";
  return DOT_STYLE;
}({});